import { useComponentInView } from "../../../hooks/useComponentInView";
import useOutputReportStore from "../../../store/OutputReport.store";
import "../staticPageReport.scss";

const StaticPageThree = () => {
  const { ref } = useComponentInView();

  const metadata = useOutputReportStore().metadata;
  const sectionMetadata = metadata?.FirmOverview || {};
  const { sectionKeyKebab, assetType } = sectionMetadata;

  if (!metadata?.Cover?.TransitionId) return null;

  return (
    <article
      ref={ref}
      id={`section-${sectionKeyKebab}-3`}
      className="static-page-report report-article"
    >
      <header className="section-title report-article__header">
        <h1>About this Transition Report</h1>
      </header>

      <div className="report-article__content">
        <section className="report-article__visual">
          <div className="static-page-report__footnote">
            This transition report aims to provide relevant information about
            transitioning from a current portfolio of securities to the
            preferred strategy (e.g., 1- to 10-year Municipal Ladder) while
            incorporating customization features, such as state-specific or
            state preference, as appropriate. The report summarizes the tax
            implications, portfolio characteristics, maturity structure,
            proposed sales, and other relevant information associated with
            transitioning to an Allspring SMA strategy.
            <br />
            <br />
            No client needs are alike, so we believe in presenting several
            options on the following pages for a thoughtful transition from the
            current portfolio to the desired strategy.
            <br />
            <br />
            <span className="static-page-report__footnote-highlight">
              1. The Sample Representative Portfolio
            </span>{" "}
            (SRP) consists of securities pre-selected to achieve specific
            characteristics with a corresponding risk representative of the
            strategy.
            <br />
            <br />
            <span className="static-page-report__footnote-highlight">
              2. The Minimize Tax Liability Portfolio
            </span>{" "}
            aims to minimize the tax cost of a transition with a secondary
            objective of reducing tracking error versus the SRP.
            <br />
            <br />
            <span className="static-page-report__footnote-highlight">
              3. The Minimize Tracking Error Portfolio
            </span>{" "}
            aims to minimize tracking error relative to the SRP with a secondary
            objective of reducing tax costs.
            <br />
            <br />
            {assetType !== "equity" && (
              <>
                <span className="static-page-report__footnote-highlight">
                  4. The Balance Tax Liability & Tracking Error Portfolio
                </span>{" "}
                aims to minimize tax costs and tracking error with equal
                emphasis.
                <br />
                <br />
              </>
            )}
            It's worth noting that the report is for illustrative purposes only
            and references market data as of the date referenced on the cover
            page. Actual tax implications, portfolio characteristics, and
            holdings may differ at the time of funding.
            <div className="static-page-report__footnote-spacer" />
            <p className="static-page-report__footnote-legal">
              For Investment Professional Use Only In One-On-One Presentation
              With Client
            </p>
          </div>
        </section>
      </div>
    </article>
  );
};

export default StaticPageThree;
